/*** constants for push build values general***/
export const PUSH_VALUE = "PUSH_VALUE";

/*** size of cell ***/
export const SIZE_OF_CELL  = 20;
export const SIZE_OF_CHANGE_STEP = 5;

/*** constants for build values sides ***/
export const SET_SIDE_OPTION = "SET_SIDE_OPTION";
export const DUPLICATE_SIDE = "DUPLICATE_SIDE";
export const ADD_SIDE_LID = "ADD_SIDE_LID";
export const ADD_SLEEVE = "ADD_DELETE_SLEEVE";
export const DELETE_SLEEVE = "DELETE_SLEEVE";
export const CHANGE_NUMBER_OF_CELLS = "CHANGE_NUMBER_OF_CELLS";
export const PUSH_LID_TO_TARGET = "PUSH_LID_TO_TARGET";
export const DELETE_LID = "DELETE_LID";
export const IS_VISITED_FINISH = "IS_VISITED_FINISH";
export const DELETE_FROM_PLAN ="DELETE_FROM_PLAN";
export const PUSH_DATA_FROM_FORM = "PUSH_DATA_FROM_FORM";
export const RESET = "RESET";
export const REDIRECT_LINK = "https://www.mm-mannhart.ch/vielen-dank-app/";
export const LOCALSTORAGE_KEY = "manhart";

export const sleeveSize = {
    "#f8e71c" : 10,
    "#bd10e0" : 12.5,
    "#50e3c2" : 14.5,
    "#d0021b" : 17,
    "#7ed321" : 21.5,
    "#000000" : 30,
    "#8b572a" : 8.5
};



// WEBPACK FOOTER //
// ./src/constants/constants.js